export default __webpack_public_path__ + "static/media/accessories.5db8ae4c.svg";